// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDNyJZmg3qD3cjUgX41w__WOcBJrHW0Xu4",
    authDomain: "zettask-312ac.firebaseapp.com",
    databaseURL: "https://zettask-312ac.firebaseio.com",
    projectId: "zettask-312ac",
    storageBucket: "zettask-312ac.appspot.com",
    messagingSenderId: "867837762728",
    appId: "1:867837762728:web:ebf70b1a95f290b8d1b69d",
    measurementId: "G-XK480XW5WD"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
